/**
 * Прежняя фамилия, найденная в загруженном документе (26.10.2026).
 *
 * Справка МВД, кредитный отчёт и сведения ЕГРН называют должника и прежней
 * фамилией. Если имя и отчество совпадают с делом, а фамилия другая —
 * предлагается внести её в «Прежние фамилия, имя, отчество» (графа формы
 * № 530 обязательная). Внесённая фамилия больше не предлагается.
 */

import { previousSurnames, type CaseProfile } from '@bd/domain';

export function PreviousNameHint({
  names,
  profile,
  update,
  readOnly,
}: {
  names: string[];
  profile: CaseProfile;
  update: (apply: (p: CaseProfile) => CaseProfile) => void;
  readOnly?: boolean;
}) {
  const surnames = previousSurnames(names, profile.debtor);
  if (surnames.length === 0) return null;

  return (
    <>
      {surnames.map((surname) => (
        <p key={surname} className="warning">
          В документе должник значится и под фамилией «{surname}» — это прежняя фамилия.{' '}
          <button
            type="button"
            className="link-button"
            disabled={readOnly}
            onClick={() =>
              update((p) => ({ ...p, debtor: { ...p.debtor, previousNames: [...(p.debtor.previousNames ?? []), surname] } }))
            }
          >
            Внести в «Прежние фамилия, имя, отчество»
          </button>
        </p>
      ))}
    </>
  );
}
